import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { WwwDirectusService, Show } from 'www-cms';

export const ticketingShowResolver: ResolveFn<Show> = (route, state) => {
  const directus = inject(WwwDirectusService);
  const eventCode = route.paramMap.get('eventCode');
  return directus.getShow(eventCode!);
};
